import firebase from 'firebase'
export let firerequest = firebase.database().ref('/requests');
export let firefriends = firebase.database().ref('/friends');
export let firechats = firebase.database().ref('/chats');
export let fireusers = firebase.database().ref('/users');
export let firegroups = firebase.database().ref('/groups');
export let firemessagecount = firebase.database().ref('/messageCount');
export let firetyping = firebase.database().ref('/typingMessage');
export let fireblockfriends = firebase.database().ref('/blockfriends');
export let firereportfriends = firebase.database().ref('/reportfriends');
export let firenotifications = firebase.database().ref('/userNotifications');
export let fireposts = firebase.database().ref('/postMessages');


